import React, { useState } from 'react';
import * as ReduxModal from 'redux-modal';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import AvatarIcon from '../../assets/img/avatar.svg';
import RoundCheckButton from './RoundCheckButton';
import { giveAdminRights } from '../../actions/adminActions';
import { isEmpty, filter } from 'lodash';
import EmptyCheckButton from './EmptyCheckButton';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { getAllSpots } from '../../actions/parkingSpotActions';
import { getAllLots } from '../../actions/parkingLotActions';

function User({ lastName, firstName, email, userId, roles }) {
  const [displayMenu, setDisplayMenu] = useState(false);
  // useEffect(() => {
  //   Promise.all([dispatch(getAllSpots()), dispatch(getAllLots())]).catch(() => {
  //     toast.error('Chyba ve spojení se serverem.');
  //   });
  // }, []);
  const dispatch = useDispatch();
  const showModal = () => {
    dispatch(ReduxModal.show('userPermanentParkingLotModal', { userId }));
  };
  const hasAdminRole = !isEmpty(
    filter(roles, (role) => role.name === 'ROLE_ADMIN')
  );
  const changeAdminRights = () => {
    dispatch(giveAdminRights(userId, hasAdminRole));
  };
  const isAdmin = !isEmpty(
    filter(roles, (role) => role.name === 'ROLE_ADMIN' && role.active === true)
  );

  return (
    <div className="user">
      <div className="user-main">
        <span>
          <img className="user-image" src={AvatarIcon} alt="Avatar" />
          {lastName} {firstName}
        </span>
        <span>{email}</span>
        <span
          role="button"
          onClick={() => setDisplayMenu(!displayMenu)}
          tabIndex={0}
          onKeyPress={() => setDisplayMenu(!displayMenu)}
        >
          <i className="fas fa-chevron-down" />
        </span>
      </div>
      {displayMenu ? (
        <div className="user-menu">
          <hr className="user-line" />
          <div className="user-menu__items">
            {/* <span onClick={showModal}>
              <EmptyCheckButton />
              Stálé místo
            </span> */}
            <span onClick={changeAdminRights}>
              <RoundCheckButton active={isAdmin} />
              Administrátorská práva
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default User;

User.propTypes = {
  lastName: PropTypes.string,
  firstName: PropTypes.string,
  email: PropTypes.string
};

User.defaultProps = {
  lastName: '',
  firstName: '',
  email: ''
};
